import { FC } from "react";
import Card from "@/components/shared/card/Card";
import HistoryItem from "./HistoryItem";
import { HistoryTransaction } from "@/types/history";

interface HistoryProps {
    transactions?: HistoryTransaction[];
    isLoading?: boolean;
    error?: string;
}

const History: FC<HistoryProps> = ({ transactions = [], isLoading = false, error }) => {
    // Retry handler (optional, expects parent to pass a retry function if needed)
    const handleRetry = () => {
        window.location.reload(); // Simple: reloads the page. Replace with smarter retry if available.
    };

    if (error) {
        return (
            <Card className="hidden lg:flex">
                <div className="text-center py-4 flex flex-col items-center gap-2">
                    <p className="text-error">{error}</p>
                    {error.includes("429") ? (
                        <p className="text-sm text-muted">You are being rate limited. Please wait and try again.</p>
                    ) : null}
                    <button
                        className="mt-2 px-4 py-2 rounded bg-accent text-white hover:bg-accent-dark transition"
                        onClick={handleRetry}
                    >
                        Retry
                    </button>
                </div>
            </Card>
        );
    }

    if (isLoading) {
        return (
            <Card>
                <div className="text-center py-4">
                    <p className="text-muted">Loading snipe history...</p>
                </div>
            </Card>
        );
    }

    if (!transactions.length) {
        return (
            <Card className="hidden lg:flex">
                <div className="text-center py-8">
                    <h2 className="text-lg text-accent mb-2">No Snipe History</h2>
                    <p className="text-muted">
                        You haven't sniped any tokens yet. Start a snipe and your history will show up here!
                    </p>
                </div>
            </Card>
        );
    }

    return (
        <Card className="hidden md:flex overflow-y-auto scrollbar scrollbar-w-1 scrollbar-track-rounded-full scrollbar-thumb-rounded-full">
            <h2 className="text-lg text-accent">Snipe History</h2>
            <ul className="flex flex-col divide-y divide-muted">
                {transactions.map((transaction) => (
                    <HistoryItem
                        key={`${transaction.date}-${transaction.fromToken?.symbol || ""}-${transaction.toToken?.symbol || ""}`}
                        date={transaction.date}
                        fromAmount={transaction.fromAmount}
                        from={transaction.fromToken}
                        toAmount={transaction.toAmount}
                        to={transaction.toToken}
                    />
                ))}
            </ul>
        </Card>
    );
};

export default History;
